import './MenuList.less';

export const prefix = 'bm-c-menu-list';

export { default } from './MenuList';
